module.exports = __webpack_public_path__ + "static/media/click.ba6476be.svg";